import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { EMPTY, Observable } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { EbenProcessInstance } from '@alf-nx-workspace/eben/interfaces';
import { BpmService } from '@alf-nx-workspace/shared/utils';
import { catchError } from 'rxjs/operators';
import { EbenFacade, WORKFLOW_NOT_FOUND_URL } from '@alf-nx-workspace/eben/data-access';
import { HttpErrorResponse } from '@angular/common/http';
import { take } from 'rxjs/internal/operators';

@Injectable({
  providedIn: 'root',
})
export class EbenProcessResolver implements Resolve<EbenProcessInstance> {
  readonly bpmService = inject(BpmService);
  readonly router = inject(Router);
  readonly ebenFacade = inject(EbenFacade);

  resolve(route: ActivatedRouteSnapshot): Observable<EbenProcessInstance> {
    return this.bpmService.getProcessInstanceById(route.params['processInstanceId']).pipe(
      take(1),
      catchError((error: HttpErrorResponse) => {
        this.navigateToNotFound(route.params['processInstanceId']);
        return EMPTY;
      }),
    );
  }

  private navigateToNotFound(processInstanceId: string): void {
    this.ebenFacade.navigateToOutlet(WORKFLOW_NOT_FOUND_URL.replace(':processInstanceId', processInstanceId), true);
  }

}
